import { CapacitorPrint } from 'capacitor-print';
import { I18n, Store } from '../wrappers';
/**
 * iOS print adapter: network TCP and BLE ESC/POS printers only.
 * Vendor/integrated printers are Android-POS-terminal hardware and USB
 * peripherals are not accessible from iOS — neither is offered
 * (docs/IOSPort.md §8 D5/D10). PDF/share-sheet fallback is
 * handled by PrintService itself, as on Android.
 */
const PrintServiceIOS = {
    async init() {
        // Nothing to initialize: the BLE permission prompt appears on the
        // first BLE print (CoreBluetooth semantics); Bluetooth cannot be
        // programmatically enabled on iOS.
    },
    async detectPrinters() {
        const terminal = Store.get('terminal');
        const networkPrinter = {
            terminal: terminal,
            printer: { name: 'network_printer', description: I18n.t('printers.network') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 48,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        const bluetoothPrinter = {
            terminal: terminal,
            printer: { name: 'bluetooth_printer', description: I18n.t('printers.bluetooth') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 32,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        return [networkPrinter, bluetoothPrinter];
    },
    async sendToPrinter(printer, data) {
        try {
            if (printer.printer.name === 'bluetooth_printer') {
                let permissions = await CapacitorPrint.checkPermissions();
                if (permissions.bluetooth !== 'granted') {
                    permissions = await CapacitorPrint.requestPermissions();
                }
            }
            CapacitorPrint.print({ printer, data });
        }
        catch (error) {
            return { success: false };
        }
        return { success: true };
    },
    /**
     * Open printer cash drawer — same contract as Android.
     */
    async openDrawer(printer) {
        return { success: false, error: 'not_supported' };
    },
    /**
     * Whether the installed native build prints the receipt logo line. A build from before the
     * logo has no `capabilities` method: the call rejects, which counts as no.
     */
    async canPrintLogo() {
        try {
            const capabilities = await CapacitorPrint.capabilities();
            return capabilities?.logo === true;
        }
        catch {
            return false;
        }
    },
};
export default PrintServiceIOS;
//# sourceMappingURL=PrintServiceIOS.js.map